import React from "react";
import { cx, css } from "@emotion/css";
import moment from "moment";
import bs from "../css/bootstrap.module.css";

const Footer = () => {
  const pageFooter = css`
    width: 100%;
    clear: both;
    margin-top: 3em;
  `;
  const pageFooterTop = css`
    width: 100%;
    background: #3b3e3e;
    color: #fff;
    min-height: 65px;
    label: pageFooterTop;
    p {
      line-height: 65px;
      text-align: center;
      margin: 0;
    }
  `;
  const pageFooterBottom = css`
    margin-top: 1.75em;
    label: pageFooterBottom;
  `;
  const disclsoure = css`
    color: #767c7c;
    font-weight: bold;
    line-height: 1.6em;
    a {
      font-weight: bold;
    }
  `;
  const stylesLeftFooter = css`
    font-family: "Roboto", sans-serif;
    font-weight: normal;
    line-height: 1.2em;
    box-sizing: border-box;
    ul {
      margin: 0;
      padding: 0 0 10px;
      li {
        list-style-type: none;
        border-right: 1px solid #272929;
        padding: 0 8px;
        display: inline-block;
        a {
          color: #007eb7;
          line-height: 1.6em;
          text-decoration: none;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      li:first-of-type {
        padding-left: 0;
      }
      li:last-child {
        border-right: none;
      }
    }
    p,
    a {
      font-size: 0.85em;
    }
  `;

  return (
    <footer className={pageFooter}>
      <div className={pageFooterTop}>
        <div className={bs.container}>
          <div className={bs.row}>
            <div className={bs["col-md-12"]}>
              <p>Need Help? Call us at 844-4AM-CENTURY</p>
            </div>
          </div>
        </div>
      </div>
      <div className={cx(pageFooterBottom, bs.container)}>
        <div className={bs.row}>
          <div className={cx(bs["col-md-12"], stylesLeftFooter)}>
            <p>
              Copyright {moment().year()} American Century Proprietary Holdings
              Inc.
            </p>
            <p>All rights reserved.</p>
            <p>All dates and times are based on Central time.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
